import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Customer } from '../../../models/customer/customer';
import { TextModes } from '../../ui/controls/text-input/text-input.component';
import { CustomerService } from '../../../models/customer/customerService';
import { UIHelpers } from '../../../core/ui-helpers';
import { UIErrorHandler } from '../../../core/uiErrorHandler';
import { StreetAddress } from '../../../models/streetAddress/streetAddress';
import { BaseComponent } from '../../baseComponent';
import { FormMode } from '../../../core/constants';

@Component({
  selector: 'app-customer-info',
  templateUrl: './customer-info.component.html',
  standalone: false,
})
export class CustomerInfoComponent extends BaseComponent {
  @Input() customer: Partial<Customer> = Customer.createEmpty();
  @Input() enableEditing: boolean = false;
  @Input() mode: FormMode = FormMode.View;
  @Input() enableDataStore: boolean = false;
  @Output() saved = new EventEmitter<boolean>();

  data: Partial<Customer> = Customer.createEmpty();

  inputTextModes = TextModes;

  constructor(
    public customerService: CustomerService,
    public uiHelpers: UIHelpers,
    private uiErrorHandler: UIErrorHandler,
  ) {
    super();
  }

  ngOnInit() {
    this.copyModelData(this.customer, this.data);
  }

  public getData(customerData: Partial<Customer>) {
    customerData.firstName = this.data.firstName;
    customerData.lastName = this.data.lastName;
    customerData.emailAddress = this.data.emailAddress;
    customerData.phone = this.data.phone;

    if (this.data.streetAddress) {
      customerData.streetAddress = this.data.streetAddress;
    }
  }

  private copyModelData(
    source: Partial<Customer>,
    destination: Partial<Customer>,
  ) {
    destination.id = source.id;
    destination.firstName = source.firstName;
    destination.lastName = source.lastName;
    destination.emailAddress = source.emailAddress;
    destination.phone = source.phone;
    if (source.streetAddress) {
      destination.streetAddress = StreetAddress.clone(source.streetAddress);
    }
  }

  public btnEdit_click() {
    this.copyModelData(this.customer, this.data);
    this.mode = FormMode.Edit;
  }

  public async btnSave_click() {
    var that = this;

    this.customerService
      .patchCustomerContactInfo(this.data)
      .then((savedCustomer) => {
        that.copyModelData(savedCustomer, that.data);
        that.copyModelData(that.data, that.customer);

        that.saved.emit(true);

        that.mode = FormMode.View;
      })
      .catch((message) => {
        this.uiErrorHandler.handleError(message);
      });
  }

  public btnCancel_click() {
    this.copyModelData(this.customer, this.data);
    this.mode = FormMode.View;
    this.saved.emit(false);
  }
}
